/**
 * @generated SignedSource<<538d8aab642453e933142ae217246169>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ResourceManagement_company$data = {
  readonly isUsingSchedulingPlanMode: boolean | null;
  readonly isUsingProjectAllocation: boolean | null;
  readonly isUsingMixedAllocation: boolean | null;
  readonly " $fragmentType": "ResourceManagement_company";
};
export type ResourceManagement_company$key = {
  readonly " $data"?: ResourceManagement_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResourceManagement_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResourceManagement_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsingSchedulingPlanMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsingProjectAllocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsingMixedAllocation",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "e99e2ebe68d047b17c2502dc86370e9b";

export default node;
